import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaTwitter, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';

const quickLinksLeft = [
    { to: "/about", label: "Our Journey" },
    { to: "/projects", label: "Our Programs" },
    { to: "/our-impact", label: "Our Impact" },
];

const quickLinksRight = [
    { to: "/where-we-work", label: "Where We Work" },
    { to: "/training-center", label: "Training Center" },
    { to: "/how-to-help", label: "How to Help" },
    { to: "/csr-success-stories", label: "CSR Success Stories" },
    { to: "/contact", label: "Contact Us" },
];

const Footer = ({ darkMode }) => {
    const bgColor = darkMode ? '#1B5E20' : '#A5D6A7';
    const textColor = darkMode ? '#ffffff' : '#1B5E20';
    const linkColor = darkMode ? '#C8E6C9' : '#1B5E20';
    const hrColor = darkMode ? '#A5D6A7' : '#2E7D32';

    return (
        <footer style={{
            backgroundColor: bgColor,
            color: textColor,
            padding: '40px 0 20px',
        }}>
            <Container>
                <Row className="mb-4">
                    <Col md={4} className="mb-3">
                        <h5 style={{ fontWeight: '600' }}>Pruthvisangram Gramvikas Sanstha</h5>
                        <p style={{ fontSize: '0.9rem', opacity: 0.85 }}>
                            Fostering sustainable rural development through climate action,
                            community empowerment, and innovative solutions since 2003.
                        </p>
                    </Col>
                    <Col md={4} className="mb-3">
                        <h5 style={{ fontWeight: '600' }}>Quick Links</h5>
                        <Row>
                            <Col xs={6}>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {quickLinksLeft.map((link, i) => (
                                        <li key={i} style={{ marginBottom: '6px' }}>
                                            <Link to={link.to} style={{ color: linkColor, textDecoration: 'none', fontSize: '0.9rem' }}>
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                            <Col xs={6}>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {quickLinksRight.map((link, i) => (
                                        <li key={i} style={{ marginBottom: '6px' }}>
                                            <Link to={link.to} style={{ color: linkColor, textDecoration: 'none', fontSize: '0.9rem' }}>
                                                {link.label}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} className="mb-3">
                        <h5 style={{ fontWeight: '600' }}>Contact</h5>
                        <p style={{ fontSize: '0.9rem', marginBottom: '5px' }}>
                            <FaMapMarkerAlt className="me-2" />
                            1418, Pusedavali Road, Kadepur, Kadegaon, Sangli, Maharashtra 415305
                        </p>
                        <p style={{ fontSize: '0.9rem', marginBottom: '5px' }}>
                            <FaEnvelope className="me-2" />
                            prutvisangram@rediffmail.com
                        </p>
                    </Col>
                </Row>
                <hr style={{ borderColor: hrColor }} />
                <Row className="align-items-center">
                    <Col md={6}>
                        <p style={{ margin: 0, fontSize: '0.9rem' }}>
                            &copy; {new Date().getFullYear()} Pruthvisangram Gramvikas Sanstha. All rights reserved.
                        </p>
                    </Col>
                    <Col md={6} className="text-md-end">
                        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                           style={{ color: linkColor, margin: '0 10px', fontSize: '1.2rem' }}>
                            <FaFacebook />
                        </a>
                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                           style={{ color: linkColor, margin: '0 10px', fontSize: '1.2rem' }}>
                            <FaTwitter />
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                           style={{ color: linkColor, margin: '0 10px', fontSize: '1.2rem' }}>
                            <FaInstagram />
                        </a>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
